import { SET_AVAILABLE_COINS, SET_USER_EXTENDED_CHALLENGES, SET_ENROLLED_SKILLS, SET_USER_ACTIVITY, EDIT_LAST_PLAYED, EDIT_LAST_PLAYED_COURSE, EDIT_LAST_VISITED_SKILL, EDIT_REDIRECT_TYPE, EDIT_LAST_VISITED_COURSE, EDIT_LAST_VISITED_MSKILL_DETAILS, EDIT_LAST_VISITED_CERTIFICATE, EDIT_LAST_VISITED_CONTENT, EDIT_LAST_UNLOCKED_CERTIFICATE_IMAGE, EDIT_PRICING_BANNER, SET_USER_CHALLENGE_DATA, EDIT_USER_CHALLENGE_DATA, SET_USER_PRICING_CARD_ID, SET_LAST_CONTENT_PLAYED, EDIT_EPS_STEPS, ADD_EPS_SCORE, SET_WELCOME_MODAL_DISMISS, SET_LAST_MSKILL_COMPLETED, SET_USER_ONE_DAY_TIMER, EDIT_LAST_CHALLENGE_CERTIFICATE_ID, SET_COMPLETE_QUIZ_TIMER, SET_IS_TRIAL_BLOCKED, SET_IS_WHATSAPP, SET_IS_ACTIVATION, SET_LAST_MSKILL_DURATION, SET_USER_COIN_ACTIVITY, SET_CONTINUE_LEARNING, SET_UTM_DATA, RECOGNISED_SECTION_MODAL_DETAILS, SET_SHOW_RECOGNISED_SECTION, SET_USER_ROADMAP_STEP, SET_USER_EXPERIENCE, SET_USER_CURRENT_EDUCATION_DEGREE, SET_USER_EDUCATION_STREAM, SET_USER_IMMEDIATE_CAREER_GOAL, SET_USER_CURRENT_JOB_ROLE, SET_USER_ROADMAP_GOAL, SET_USER_IS_GOAL, SET_USER_ROADMAP_ID, SET_USER_ROADMAP_DATA, SET_USER_ROADMAP_COURSES, SET_USER_ROADMAP_PLACEMENT_SERVICES, SET_USER_SWITCH_STATE, SET_USER_ACCESS, SET_IS_SEO, SET_SEO_TYPE, SET_SEO_COURSE_SLUG, SET_IS_DELETE_ACCOUNT } from "../actions/types";
import { PURGE } from 'redux-persist'

export default function (state = {
    user_pricing_card_id: 2, is_whatsapp: false, is_activation: false, showRecognisedSection: false,
    recognisedSectionModalDetails: {}, access: {},
    recognisedSectionModalIndex: -1,
    is_seo: false, seo_type: "", seo_course_slug: "", is_delete_account: false
}, action) {
    switch (action.type) {
        case PURGE:
            return null;
        case SET_ENROLLED_SKILLS:
            if (state?.user_enrolled_skills) {
                return {
                    ...state,
                    user_enrolled_skills: [...state.user_enrolled_skills, { ...action.payload }]
                }
            } else {
                return {
                    ...state,
                    user_enrolled_skills: [{ ...action.payload }]
                }
            }
        case SET_USER_CHALLENGE_DATA:
            return {
                ...state, user_extended_challenges: [...state.user_extended_challenges, action.payload]
            }
        case EDIT_USER_CHALLENGE_DATA:
            return {
                ...state, user_extended_challenges: state.user_extended_challenges.filter(item => item?.expires_at !== action.payload?.expires_at)
            }
        case SET_USER_ACTIVITY:
            return {
                ...state,
                ...action.payload
            }
        case SET_AVAILABLE_COINS:
            return {
                ...state,
                user_coins: { ...state.user_coins, 'available-coins': action.payload }
            }
        case EDIT_LAST_PLAYED:
            return {
                ...state,
                last_played: action.payload
            }
        case EDIT_LAST_PLAYED_COURSE:
            return {
                ...state,
                last_played_course: action.payload
            }
        case EDIT_LAST_VISITED_SKILL:
            return {
                ...state, last_visited_skill_slug: action.payload
            }
        case EDIT_LAST_VISITED_COURSE:
            return {
                ...state, last_visited_course_slug: action.payload
            }
        case EDIT_REDIRECT_TYPE:
            return {
                ...state, redirect_type: action.payload
            }
        case EDIT_LAST_VISITED_MSKILL_DETAILS: {
            return {
                ...state, last_visited_mskill_details: action.payload
            }
        }
        case EDIT_LAST_VISITED_CERTIFICATE: {
            return {
                ...state, last_visited_certificate: action.payload
            }
        }
        case EDIT_LAST_VISITED_CONTENT: {
            return {
                ...state, last_visited_content: action.payload
            }
        }
        case EDIT_LAST_UNLOCKED_CERTIFICATE_IMAGE: {
            return {
                ...state, last_unlocked_certificate_image: action.payload
            }
        }
        case EDIT_PRICING_BANNER: {
            return {
                ...state, pricing_banner: action.payload
            }
        }
        case SET_USER_EXTENDED_CHALLENGES:
            return {
                ...state, user_extended_challenges: action.payload
            }
        case SET_USER_PRICING_CARD_ID: {
            return {
                ...state,
                user_pricing_card_id: action.payload
            }
        }
        case SET_LAST_CONTENT_PLAYED: {
            return {
                ...state,
                user_last_content_played: action.payload
            }
        }
        case EDIT_EPS_STEPS: {
            return {
                ...state,
                eps_steps: action.payload
            }
        }
        case ADD_EPS_SCORE: {
            return {
                ...state,
                eps_score: action.payload
            }
        }
        case SET_WELCOME_MODAL_DISMISS: {
            return {
                ...state, welcome_modal: action.payload
            }
        }
        case SET_LAST_MSKILL_COMPLETED: {
            return {
                ...state, last_mskill_completed: action.payload
            }
        }
        case SET_USER_ONE_DAY_TIMER: {
            return {
                ...state, user_one_day_timer: action.payload
            }
        }
        case EDIT_LAST_CHALLENGE_CERTIFICATE_ID: {
            return {
                ...state, challenge_certificate_id: action.payload
            }
        }
        case SET_COMPLETE_QUIZ_TIMER: {
            return {
                ...state, user_complete_quiz_timer: action.payload
            }
        }
        case SET_IS_TRIAL_BLOCKED: {
            return {
                ...state, user_trial_blocked: action.payload
            }
        }
        case SET_IS_WHATSAPP: {
            return {
                ...state, is_whatsapp: action.payload
            }
        }
        case SET_IS_ACTIVATION: {
            return {
                ...state, is_activation: action.payload
            }
        }
        case SET_LAST_MSKILL_DURATION: {
            return {
                ...state, last_mskill_duration: action.payload
            }
        }
        case SET_USER_COIN_ACTIVITY: {
            return {
                ...state, user_coin_activity: action.payload
            }
        }
        case SET_CONTINUE_LEARNING: {
            return {
                ...state, user_continue_learning: action.payload
            }
        }
        case SET_UTM_DATA: {
            return {
                ...state, utm_data: action.payload
            }
        }
        case RECOGNISED_SECTION_MODAL_DETAILS: {

            const { item, originalIndex } = action.payload
            state.recognisedSectionModalDetails = item
            state.recognisedSectionModalIndex = originalIndex
            return {
                ...state,
                recognisedSectionModalDetails: item,
                recognisedSectionModalIndex: originalIndex
            }
        }
        case SET_SHOW_RECOGNISED_SECTION: {
            return {
                ...state,
                showRecognisedSection: action.payload
            }
        }
        case SET_USER_ROADMAP_STEP: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, step: action.payload }
            }
        }
        case SET_USER_EXPERIENCE: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, employment_status: action.payload }
            }
        }
        case SET_USER_CURRENT_EDUCATION_DEGREE: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, education_current_degree: action.payload }
            }
        }
        case SET_USER_EDUCATION_STREAM: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, education_stream: action.payload }
            }
        }
        case SET_USER_IMMEDIATE_CAREER_GOAL: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, immediate_career_goal: action.payload }
            }
        }
        case SET_USER_CURRENT_JOB_ROLE: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, current_job_role: action.payload }
            }
        }
        case SET_USER_ROADMAP_GOAL: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, roadmap_goal: action.payload }
            }
        }
        case SET_USER_IS_GOAL: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, is_goal: action.payload }
            }
        }
        case SET_USER_ROADMAP_ID: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, id: action.payload }
            }
        }
        case SET_USER_ROADMAP_DATA: {
            return {
                ...state, roadmap_details: action.payload
            }
        }
        case SET_USER_ROADMAP_COURSES: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, roadmap_courses: action.payload }
            }
        }
        case SET_USER_ROADMAP_PLACEMENT_SERVICES: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, roadmap_placement_services: action.payload }
            }
        }
        case SET_USER_SWITCH_STATE: {
            return {
                ...state, roadmap_details: { ...state?.roadmap_details, switch_state: action.payload }
            }
        }
        case SET_USER_ACCESS: {
            return {
                ...state, access: action.payload
            }
        }
        case SET_IS_SEO: {
            return {
                ...state, is_seo: action.payload
            }
        }
        case SET_SEO_TYPE: {
            return {
                ...state, seo_type: action.payload
            }
        }
        case SET_SEO_COURSE_SLUG: {
            return {
                ...state, seo_course_slug: action.payload
            }
        }
        case SET_IS_DELETE_ACCOUNT: {
            return {
                ...state, is_delete_account: action.payload
            }
        }
        default:
            return state;
    }
}